import { Typography, Grid } from '@mui/material';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

import Button from '../../components/Buttons/Button';

const TokenExpired = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <Grid
      container
      direction='column'
      alignItems='center'
    >
      <Grid
        item
        xs={12}
      >
        <Typography
          variant='h2'
          gutterBottom
        >
          {intl.formatMessage({ id: 'tokenExpiredTitle' })}
        </Typography>
        <br />
        <Typography gutterBottom>
          {intl.formatMessage({ id: 'tokenExpiredMessage' })}
          <br />
          {intl.formatMessage({ id: 'tokenExpiredContactSupport' })}
        </Typography>
        <br />
        <Button
          type='submit'
          onClick={() => {
            navigate('/');
          }}
          label={intl.formatMessage({ id: 'backToHomepage' })}
        />
      </Grid>
    </Grid>
  );
};

export default TokenExpired;
